export const config = {
    subPath: '',
    // apiHostGw: 'http://10.10.0.99:8006'
    apiHostGw: 'https://api-gw2.sampangkab.go.id/lapor-mbg'
}